export const ORDER_STATUS_EDITABLE = [1, 2, 3, 8];
export const ORDER_STATUS_DISPATCHABLE = [2, 7, 8];
export const ORDER_STATUS_EXTRA_DELIVERY_DISALLOWED = [2, 7, 10, 13, 15];
export const ORDER_STATUS_FINISHABLE = [5, 21];

export const ORDER_STATUS_CANCELLED = 377;

export const NO_DISPATCHED_ORDER_MESSAGE =
  "Nenhum pedido despachado, assim que despachar algum ele irá aparecer\n" +
  "          aqui para o seu controle.";

export const NO_PREPARING_ORDER_MESSAGE =
  "Nenhum pedido em preparo. Pode levar até 45 segundos para os pedidos\n" +
  "          aparecerem, mas não deve demorar mais do que isso.";

export const NO_PACKING_ORDER_MESSAGE = "Nenhum pedido para ser embalado";

export const CREATING_ORDER_PHRASES = [
  "Preparando ingredientes",
  "Ligando a chapa",
  "Pescando o peixe",
  "Separando o feijão",
];

export const OrderTotalRanking = {
  LOW: 1,
  REGULAR: 2,
  SPECIAL: 3,
};

export const ORDER_RANKING = {
  LOW: 1,
  REGULAR: 2,
  SPECIAL: 3,
};

export const ORDER_TYPES = {
  DELIVERY: "DELIVERY",
  TAKEOUT: "TAKEOUT",
  TAKEOUT_PT: "Retirada",
  INDOOR: "INDOOR",
  INDOOR_PT: "Interior",
};

export const DESIGN_TOKENS = {
  spacing: {
    xs: 0.5,
    sm: 1,
    md: 1.5,
    lg: 2,
    xl: 3,
  },
  borderRadius: {
    sm: 1,
    md: 1.5,
    lg: 2,
  },
  iconSize: {
    sm: 16,
    md: 20,
    lg: 24,
  },
  avatarSize: {
    sm: 32,
    md: 36,
  },
  chipHeight: {
    sm: 22,
    md: 26,
  },
  fontSize: {
    xs: "0.75rem",
    sm: "0.875rem",
    base: "1rem",
    lg: "1.125rem",
  },
  touchTarget: 44,
};

export const STATUS_DISPATCHABLE = [1, 2, 8, 13, 21];
export const STATUS_EXTRA_DELIVERY_DISALLOWED = [0, 34, 377, 987];
export const STATUS_LATE_RELEVANT = [2, 7];
export const STATUS_PACKED_CONTROL = [0, 1, 2];

export const ANIMATION_VARIANTS = {
  item: {
    hidden: { y: 10, opacity: 0 },
    show: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 24,
      },
    },
    exit: {
      y: -10,
      opacity: 0,
      transition: { duration: 0.2 },
    },
  },
  icon: {
    hover: {
      scale: 1.1,
      transition: { duration: 0.2 },
    },
    tap: {
      scale: 0.95,
      transition: { duration: 0.1 },
    },
  },
};
